import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ColorIconButton } from "../../../controls";
import { ITierRowProps } from "./passenger-addition.models";
import { PassengerAdditionRowStyled } from "./passenger-addition.styled";

export const PassengerAdditionTierRow: FC<ITierRowProps> = ({
  from,
  price,
  onEdit,
  onClear,
}) => {
  const { t } = useTranslation();
  return (
    <PassengerAdditionRowStyled data-e2e-template="passenger-tier-row">
      <p>
        {t("priceRate.formLabel.passengersPricing.fromPassenger")} {from}
      </p>
      <p>{price}</p>
      <div>
        <ColorIconButton iconType="EDIT" onClick={onEdit} />
        <ColorIconButton iconType="DELETE" onClick={onClear} />
      </div>
    </PassengerAdditionRowStyled>
  );
};
